<template>
  <div style="background-color:#F9F9F9">
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#00a972" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout wrap justify-space-around>
      <v-flex xs12 md12 pa-0>
        <!-- <v-card id="app_height" outlined tile> -->
        <v-layout wrap justify-center>
          <v-flex xs12 sm12 md2>
            <sidebar />
          </v-flex>
          <v-flex id="app_signup" xs12 sm12 md10 pl-2>
            <ProjectOverview
              v-if="dataretrived"
              v-bind:projectData="projectData"
              style="padding-top:20px"
              id="ProjectOverview"
            />
            <InvestmentSummary
              v-if="dataretrived"
              v-bind:projectData="projectData"
              id="InvestmentSummary"
            />
            <KeyTargetMetrics
              v-if="dataretrived"
              v-bind:projectData="projectData"
              id="KeyTargetMetrics"
            />
            <KeyPartners v-if="dataretrived" v-bind:projectData="projectData" id="KeyPartners" />
            <ProgressToDate
              v-if="dataretrived"
              v-bind:projectData="projectData"
              id="ProgressToDate"
            />
            <FundingDetails
              v-if="dataretrived"
              v-bind:projectData="projectData"
              id="FundingDetails"
            />
            <RiskAndDisclosure
              v-if="dataretrived"
              v-bind:projectData="projectData"
              id="RiskAndDisclosure"
            />
            <Documents v-if="dataretrived" v-bind:projectData="projectData" id="Documents" />
            <Investors v-if="dataretrived" v-bind:projectData="projectData" id="Investors" />
            <Team v-if="dataretrived" v-bind:projectData="projectData" id="Team" />
            <FAQ v-if="dataretrived" v-bind:projectData="projectData" id="FAQ" />
          </v-flex>
        </v-layout>
        <!-- </v-card> -->
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";

import Sidebar from "./../Project/Sidebar";
import ProjectOverview from "./../Project/ProjectOverview";
import InvestmentSummary from "./../Project/InvestmentSummary";
import KeyTargetMetrics from "./../Project/KeyTargetMetrics";
import KeyPartners from "./../Project/KeyPartners";
import ProgressToDate from "./../Project/ProgressToDate";
import FundingDetails from "./../Project/FundingDetails";
import RiskAndDisclosure from "./../Project/RiskAndDisclosure";
import Documents from "./../Project/Documents";
import Investors from "./../Project/Investors";
import Team from "./../Project/Team";
import FAQ from "./../Project/FAQ";

export default {
  props: ["id"],
  components: {
    Sidebar,
    ProjectOverview,
    InvestmentSummary,
    KeyTargetMetrics,
    KeyPartners,
    ProgressToDate,
    FundingDetails,
    RiskAndDisclosure,
    Documents,
    Investors,
    Team,
    FAQ
  },
  data() {
    return {
      appLoading: false,
      showsnackbar: false,
      timeout: 5000,
      msg: null,
      ServerError: false,
      dataretrived: false,
      projectData: []
    };
  },
  beforeMount() {
    this.getData();
    this.getProfile();
  },
  methods: {
    getProfile() {
      this.appLoading1 = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading1 = false;
          if (response.data.status) {
            if (response.data.data.profilestep == 0) {
              this.$router.push("/CompleteProfile");
            } else if (response.data.data.profilestep == 1) {
              this.$router.push("/DocumentsUpload");
            } else if (response.data.data.profilestep == 2) {
              this.$router.push("/registrationAcknowledgement");
            }
          }
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    scrollMeTo(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;
      window.scrollTo(0, top);
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/project/get",
        params: {
          id: this.id
        },
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.dataretrived = true;
          if (response.data.status === true) {
            this.projectData = response.data.data;
            // console.log("Project Data", this.projectData);
          }
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    }
  }
};
</script>
<style>
#app_signup {
  background-image: url("../../assets/home_header.png");
  background-repeat: no-repeat;
  background-size: contain;
  /* background-size: cover; */
  /* background-attachment: fixed; */
}
@media only screen and (min-width: 800px) {
  #app_height {
    min-height: 80vh;
  }
}
</style>